import React, { useContext } from 'react'

import { useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'

import AnalyticsPostCampaignReportListViewProfile from '@components/Analytics/PostCampaignReport/ListView/Profile/Profile'
import { getBackgroundColor } from '@components/Analytics/PostCampaignReport/Post/List/List'
import { CampaignContext } from '@context/Campaign'
import { PCRChannels } from '@enums'
import { IApplicationState } from '@store'
import { selectStoryMetricIds } from '@store/postCampaignReport'
import { selectCampaignId } from '@store/router'
import { Container } from '@tribegroup'
import AnalyticsPostCampaignReportListViewHeaders from '../../ListView/Headers/Headers'
import AnalyticsPostCampaignReportListView from '../../ListView/ListView'
import AnalyticsPostCampaignReportStoryListItem from './Item/Item'

const AnalyticsPostCampaignReportStoryList: React.FC = () => {
  const {
    campaign: { is_price_hidden: isPriceHidden },
  } = useContext(CampaignContext)

  const match = useRouteMatch()
  const campaignId = selectCampaignId(match) as number
  const submissionIds = useSelector((state: IApplicationState) =>
    selectStoryMetricIds(state, campaignId, PCRChannels.IGStories),
  )

  const translationKeys = ['published', !isPriceHidden && 'spend', 'followers'].filter(
    Boolean,
  ) as ReadonlyArray<string>

  const profiles = submissionIds.map((submissionId, index) => (
    <Container data-testid="story-profile-wrapper" key={`profile-${submissionId}`}>
      <AnalyticsPostCampaignReportListViewProfile
        backgroundColor={getBackgroundColor(index)}
        submissionId={submissionId}
      />
    </Container>
  ))

  return (
    <AnalyticsPostCampaignReportListView
      profiles={profiles}
      headers={
        <AnalyticsPostCampaignReportListViewHeaders
          translationKeys={translationKeys}
          isPriceHidden={isPriceHidden}
        />
      }
    >
      {submissionIds.map((submissionId, index) => (
        <Container key={`story-list-${submissionId}`} data-testid="story-list-item">
          <AnalyticsPostCampaignReportStoryListItem
            submissionId={submissionId}
            backgroundColor={getBackgroundColor(index)}
          />
        </Container>
      ))}
    </AnalyticsPostCampaignReportListView>
  )
}

export default AnalyticsPostCampaignReportStoryList
